// Portal destinations are placeholders until Cabinetry.Online confirms the live PFPC configuration.
export const PORTAL_REGISTER_URL = "https://example.com/pfpc/register"; // TODO: replace before launch
export const PORTAL_LOGIN_URL = "https://example.com/pfpc/login"; // TODO: replace before launch
export const PORTAL_SHOP_URL = "https://example.com/pfpc/shop"; // TODO: replace before launch
export const PORTAL_SUPPORT_URL = "/help/"; // TODO: confirm whether support remains on-site

export const AUSTEN_EMAIL = "austen@lifestylecabinets.com.au"; // Verify branded email before launch
export const LOGO_URL = "https://cdn.magicpatterns.com/uploads/oQWipBCtNrzPp1H2fySft7/PFPC_Logo.png";

// Illustrative editorial imagery. Do not represent these images as PFPC facilities, staff or completed customer work.
export const IMAGE_ASSETS = {
  panelDetail: "https://cdn.magicpatterns.com/patterns/generated-images/cf458b8d-a341-4aa7-84c9-da252a5bdedc.jpg",
  measuringSpace: "https://cdn.magicpatterns.com/patterns/generated-images/20045840-06ae-4678-850a-8f00490a3375.jpg",
  reviewingPlan: "https://cdn.magicpatterns.com/patterns/generated-images/a270a4b0-a382-4198-af41-b08758421011.jpg",
  hardwareDetail: "https://cdn.magicpatterns.com/patterns/generated-images/78e9d1b2-0d7b-477d-9248-32c2e755858f.jpg",
} as const;

export const SITE_NAVIGATION = [
  { label: "Cabinetry", href: "/cabinetry/" },
  { label: "Who We Help", href: "/who-we-help/" },
  { label: "How It Works", href: "/how-it-works/" },
  { label: "Guides", href: "/guides/" },
  { label: "About", href: "/about/" },
  { label: "Help", href: "/help/" },
] as const;
